"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
// import Box from '../box/Box';
var Overlay_1 = __importDefault(require("../Overlay"));
var TimesIcon_1 = __importDefault(require("../Icons/TimesIcon"));
var CloseButton = styled_components_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 2rem;\n  height: 2rem;\n  position: absolute;\n  top: 1rem;\n  right: 1.4rem;\n  cursor: pointer;\n  background: transparent;\n  border: 0;\n  z-index: 2;\n"], ["\n  width: 2rem;\n  height: 2rem;\n  position: absolute;\n  top: 1rem;\n  right: 1.4rem;\n  cursor: pointer;\n  background: transparent;\n  border: 0;\n  z-index: 2;\n"])));
var StyledModal = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  max-height: 90vh;\n  max-width: 90vw;\n  overflow: auto;\n  z-index: ", ";\n  width: ", ";\n  background-color: ", ";\n  display: flex;\n  flex-direction: column;\n  position: relative;\n"], ["\n  max-height: 90vh;\n  max-width: 90vw;\n  overflow: auto;\n  z-index: ", ";\n  width: ", ";\n  background-color: ", ";\n  display: flex;\n  flex-direction: column;\n  position: relative;\n"])), function (_a) {
    var zIndex = _a.zIndex;
    return zIndex;
}, function (_a) {
    var width = _a.width;
    return width;
}, function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor;
});
var Modal = function (_a) {
    var children = _a.children, visible = _a.visible, _b = _a.width, width = _b === void 0 ? '50rem' : _b, onClose = _a.onClose, _c = _a.zIndex, zIndex = _c === void 0 ? 5 : _c, _d = _a.disableOverlayClick, disableOverlayClick = _d === void 0 ? false : _d, rest = __rest(_a, ["children", "visible", "width", "onClose", "zIndex", "disableOverlayClick"]);
    if (!visible)
        return null;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Overlay_1.default, { visible: visible, onClose: onClose, disableClick: disableOverlayClick, zIndex: zIndex },
            react_1.default.createElement(StyledModal, __assign({}, rest, { zIndex: zIndex + 1, width: width, backgroundColor: "#FFF" }),
                react_1.default.createElement(CloseButton, { "data-testid": "close-button", onClick: onClose, role: "button", "aria-label": "St\u00E4ng", title: "St\u00E4ng", type: "button" },
                    react_1.default.createElement(TimesIcon_1.default, { color: "#000" })),
                children))));
};
exports.default = Modal;
var templateObject_1, templateObject_2;
